module.exports = __webpack_public_path__ + "img/barcode-scan.50002a5b.svg";